module.exports = __webpack_public_path__ + "static/media/image1.032f85b5.png";